import {BrowserRouter as Router, Switch, Route, withRouter} from 'react-router-dom';
import {observer} from 'mobx-react';
import {withState} from 'shared/core';
import ScheduleInterviewContainer from './ScheduleInterviewContainer';
import ScheduleInterviewCompleteContainer from './ScheduleInterviewCompleteContainer';
import ScheduleInterviewState from '../../state/ScheduleInterviewState';

const ScheduleInterviewRoutes = withRouter(withState(observer(({uiState}) => (
  <Switch>
    <Route exact path='/' render={() => <ScheduleInterviewContainer uiState={uiState}/>}/>
    <Route exact path='/complete' render={() => <ScheduleInterviewCompleteContainer uiState={uiState}/>}/>
  </Switch>
)), ScheduleInterviewState));

const ScheduleInterviewPage = () => {
  return (
    <Router basename='/schedule_interview'>
      <ScheduleInterviewRoutes/>
    </Router>
  );
};

export default ScheduleInterviewPage;
